module.exports = __webpack_public_path__ + "static/media/3DPPA6.a192ebb9.jpg";